import { useContext } from 'react';
import { ThemeContext } from 'contexts/ThemeContext';

export default function useTheme() {
  const ctx = useContext(ThemeContext);
  if (ctx === undefined) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return ctx;
}
